import React from 'react';
import '../../i18n';
import {LoadingSpinner} from "../LoadingSpinner";

export type WithChildren<T = {}> = T & {
    children: React.ReactNode;
};

type I18NextProviderProps = WithChildren;

const I18NProvider = ({ children }: I18NextProviderProps) => {
    return <React.Suspense fallback={<LoadingSpinner children={<></>} />}>{children}</React.Suspense>;
};

export default I18NProvider;

